import React from 'react'
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";
import DatePicker, {registerLocale} from "react-datepicker";
import {getSchoolYear} from "../../../../../utils/authority";
import GradeManager from "../../../../../components/Grade";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import vi from "date-fns/locale/vi";
import FilesApi from "../../../../../services/resource/files-api";
import TableHeader from "../../../../../components/TableHeader";
import Pagination from "../../../../../components/Pagination";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Utils from "../../../../../utils/utils";
import FeeItemController from "../../../../../services/system/fee-item/fee-item-controller";
import FeeController from "../../../../../services/system/fee/fee-controller";
registerLocale("vi", vi);
function withRouter(Component) {
    return (props) => <Component {...props} navigate={useNavigate()} params={useSearchParams()} />;
}
function uploadAdapter(loader) {
    return {
        upload: () => {
            return new Promise((resolve, reject) => {
                FilesApi.uploadFileCkeditor( loader, res => {
                    if (res.success) {
                        resolve({
                            default: res.data.url
                        });
                    }else {
                        reject(res.error);
                    }
                })
            })
        }
    }
}
function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
        return uploadAdapter(loader);
    };
}
class EditFeeManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listProduct: [],
            feeItemResList: [],
            state: "ACTIVE",
            price: 0,
            pageNumber: 0,
            pageSize: 50,
            isAllSchool: true,
            gradeId: -1,
            eatPrice: 0,
            livePrice: 0,
            currentClassRoomId: -1,

            yearId: parseInt(getSchoolYear()),
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Tên sản phẩm",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "price",
                    name: "Giá theo tháng",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "tax",
                    name: "Giá theo kỳ",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "tax",
                    name: "Giá theo năm",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "note",
                    name: "Chú thích",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "action",
                    name: "Hành động",
                    style: {textAlign: "center"},
                    sort: false
                }
            ],


            expiredDay: new Date(),
            productName: "",
            groupId: 0,


            content: "",
            classRoomId: 0,
            listClassRoom: [],
        };
    }

    componentWillMount() {
        this.getListFeeItem()
        const [searchparams] = this.props.params;
        let serviceId = searchparams.get("id");
        this.getDetailFee(serviceId);
    }
    getDetailFee = (productId) => {
        FeeController.detail(productId, res => {
            let data = res.data
            this.setState(data)
            this.setState({
                gradeId: data.grade
            });
        })
    };
    getListFeeItem() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            name: this.state.productName,
            state: "ACTIVE",
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            sort: "created_at desc"
        };
        FeeItemController.list(payload, res => {
            this.setState({
                showLoading: false,
                listProduct: res.data.content,
            });
        })
    }
    saveContent(newContent) {
        this.setState({
            content: newContent,
        });
    }
    renderStatus() {
        let listStatus = [
            {
                "id": "ACTIVE",
                "name": "Hoạt động"
            },
            {
                "id": "INACTIVE",
                "name": "Khóa"
            }
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    onEdit = () => {
        let price = parseFloat(this.state.price.toString().replaceAll(",", ""))
        let livePrice = parseFloat(this.state.livePrice.toString().replaceAll(",", ""))
        let eatPrice = parseFloat(this.state.eatPrice.toString().replaceAll(",", ""))
        if (this.state.name == "" || this.state.name.length < 5){
            toast.error("Tên cấu hình học phí phải lớn hơn 5 ký tự");
        }else if (this.state.gradeId == ""){
            toast.error("Vui lòng chọn đối tượng áp dụng");
        }else if (this.state.feeItemResList.length < 1){
            toast.error("Vui lòng thêm sản phẩm");
        }else {
            let listFeeItem = []
            this.state.feeItemResList.forEach((product) => {
                listFeeItem.push(product.id)
            })
            let payload = {
                "id": this.state.id,
                "name": this.state.name,
                "content": this.state.content,
                "grade": this.state.gradeId,
                "price": price,
                "livePrice": livePrice,
                "eatPrice": eatPrice,
                "discountSemester": parseFloat(this.state.discountSemester),
                "discountYear": parseFloat(this.state.discountYear),
                "state": this.state.state,
                "yearId": parseInt(getSchoolYear()),
                "listFeeItem": listFeeItem,
            }
            FeeController.edit(payload, res => {
                if (res.success){
                    this.props.navigate('/ad-sas-school/cau-hinh-gia-hoc-phi');
                    toast.success("Tạo cấu hình giá học phí thành công!")
                } else {
                    toast.error("Đã xảy ra lỗi! " + res.message)
                }
            })
        }
    }
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        });
    }

    getProductSelect(productId){
        let listSelected = this.state.feeItemResList;
        this.state.listProduct.forEach((product) => {
            if (product.id == productId){
                let item = listSelected.find(item => item.id === product.id);
                if (typeof item === 'undefined'){
                    listSelected.push(product)
                }
            }
        })
        this.setState({
            feeItemResList: listSelected
        })
    }
    removeProductSelect(productId){
        let filtered = this.state.feeItemResList.filter(function(el) { return el.id !== productId; });
        this.setState({
            feeItemResList: filtered
        })
    }
    render() {
        let {gradeId, feeItemResList, header} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="fee" parentClass="wallet-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Thêm mới cấu hình giá học phí"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>SỬA CẤU HÌNH GIÁ HỌC PHÍ</h2>
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên cấu hình</label>
                                                <input
                                                    placeholder="Nhập tên cấu hình"
                                                    maxLength={255} type="text"
                                                    className="col-8 form-control shadow-none"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mt-2">
                                                <label className="label-item col-4">Trạng thái</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.state}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            state: e.target.value
                                                        })
                                                    }}
                                                >
                                                    {this.renderStatus()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Học phí</label>
                                                <input
                                                    placeholder="Nhập số tiền học phí"
                                                    maxLength={255} type="text"
                                                    className="col-8 form-control shadow-none"
                                                    value={Utils.formatMoney(this.state.price)}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            price: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Chọn khối áp dụng</label>
                                                <GradeManager
                                                    gradeId={gradeId}
                                                    onUpdateGrade={(gradeId) => this.onUpdateGrade(gradeId)}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ưu đãi đóng học phí theo kỳ</label>
                                                <input
                                                    placeholder="Nhập % ưu đãi đóng học phí theo kỳ"
                                                    maxLength={255} type="text"
                                                    className="col-8 form-control shadow-none"
                                                    value={Utils.formatMoney(this.state.discountSemester)}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            discountSemester: event.target.value
                                                        })
                                                    }}
                                                />
                                                <label className="label-item pl-0">%</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ưu đãi đóng học phí theo năm</label>
                                                <input
                                                    placeholder="Nhập % ưu đãi đóng họp phí theo năm"
                                                    maxLength={255} type="text"
                                                    className="col-8 form-control shadow-none"
                                                    value={Utils.formatMoney(this.state.discountYear)}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            discountYear: event.target.value
                                                        })
                                                    }}
                                                />
                                                <label className="label-item pl-0">%</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tiền ăn trưa và ăn xế</label>
                                                <input
                                                    placeholder="Tiền ăn trưa và ăn xế"
                                                    maxLength={255} type="text"
                                                    className="col-8 form-control shadow-none"
                                                    value={Utils.formatMoney(this.state.eatPrice)}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            eatPrice: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tiền bán trú</label>
                                                <input
                                                    placeholder="Tiền bán trú"
                                                    maxLength={255} type="text"
                                                    className="col-8 form-control shadow-none"
                                                    value={Utils.formatMoney(this.state.livePrice)}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            livePrice: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Mô tả cấu hình giá học phí</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex">
                                                {/*https://www.techgalery.com/2021/05/how-to-use-react-ckeditor-upload-file.html*/}
                                                <CKEditor
                                                    config={{
                                                        extraPlugins: [uploadPlugin]
                                                    }}
                                                    editor={ ClassicEditor }
                                                    data=""
                                                    onReady={ editor => {
                                                        // You can store the "editor" and use when it is needed.
                                                        // console.log( 'Editor is ready to use!', editor );
                                                    } }
                                                    onChange={ ( event, editor ) => {
                                                        const data = editor.getData();
                                                        this.saveContent(data)
                                                    } }
                                                />
                                            </div>

                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Danh sách khoản phí
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-8 d-flex mb-2">
                                                <label className="col-xs-12 col-sm-12 col-md-4 label-item pl-0">Chọn khoản phí(<span  style={{color: "red",}}>*</span>)</label>
                                                <Autocomplete
                                                    size="small"
                                                    options={this.state.listProduct}
                                                    getOptionLabel={option => option.name?option.name:""}
                                                    style={{width: '100%'}}
                                                    inputValue={this.state.productName}
                                                    renderInput={params => {
                                                        return <TextField
                                                            placeholder='Nhập tên sản phẩm/hàng hóa'
                                                            {...params}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                                style: {
                                                                    fontSize: 17,
                                                                    backgroundColor: "#FFF",
                                                                    paddingRight: 10,
                                                                    paddingLeft: 10,
                                                                    color: '#2e495c',
                                                                    fontWeight: 500,
                                                                    fontFamily: 'Montserrat'
                                                                }
                                                            }}
                                                            label=""
                                                            variant="outlined"
                                                            fullWidth
                                                        />
                                                    }}
                                                    onInputChange={(event, val) => {
                                                        if (event !== null){
                                                            this.setState({
                                                                productName: val
                                                            })
                                                            if (val === ""){
                                                                this.state.productId = -1;
                                                            }else if (val.length>3){
                                                                this.getListFeeItem()
                                                            }
                                                        }
                                                    }}
                                                    onChange={(e, val) => {
                                                        if (val?.id != undefined){
                                                            this.getProductSelect(val?.id);
                                                        }else {
                                                            this.setState({
                                                                productId: -1,
                                                                productName: "",
                                                            })
                                                        }
                                                    }}

                                                />

                                            </div>
                                            <div className="card col-12">
                                                <div className="p-0 mb-3">
                                                    <div className="table-wrapper">
                                                        <table
                                                            className="table table-striped table-data table-responsive table-bordered">
                                                            <table className="table">
                                                                <thead>
                                                                <TableHeader
                                                                    header={header}
                                                                    clickSort={data => {
                                                                    }}
                                                                />
                                                                </thead>
                                                                {!feeItemResList ||
                                                                feeItemResList.length == 0 ? (
                                                                    <tbody>
                                                                    <tr>
                                                                        <td colSpan={12}>
                                                                            <div className="text-center">
                                                                                Không có dữ liệu
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                ) : (
                                                                    <tbody>
                                                                    {feeItemResList &&
                                                                    feeItemResList.length > 0 &&
                                                                    feeItemResList?.map((row, index) => (
                                                                        <tr style={{height: 50}}>
                                                                            <td style={{textAlign: "center"}} scope="row">
                                                                                {" "}
                                                                                {this.state.pageNumber * this.state.pageSize +
                                                                                index +
                                                                                1}
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                {row.name}
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                {Utils.formatMoney(row.priceMonth)} VNĐ
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                {Utils.formatMoney(row.priceSemester)} VNĐ
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                {Utils.formatMoney(row.priceYear)} VNĐ
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                {row.note}
                                                                            </td>
                                                                            <td style={{textAlign: "center"}}>
                                                                                <button className="btn btn-action p-2"
                                                                                        title='Xóa khoản phí'
                                                                                        style={{cursor: 'pointer'}}
                                                                                        onClick={() => {
                                                                                            this.removeProductSelect(row.id)
                                                                                        }}
                                                                                >
                                                                                    <i className="ti-trash"/>
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                    </tbody>
                                                                )}
                                                            </table>
                                                        </table>
                                                    </div>
                                                    <div className="pagination-right">
                                                        <Pagination
                                                            activePage={this.state.pageNumberActive}
                                                            itemsCountPerPage={this.state.pageSizeActive}
                                                            totalItemsCount={this.state.totalItemActive}
                                                            changeHandler={page => this.handleChangePage(page)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="align-right col-12">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                            disabled={this.state.name == ""}
                                            onClick={()=> {
                                                this.onEdit()
                                            }}
                                        >
                                            Lưu
                                        </button>
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s type-button-fix btn btn-light shadow-none"
                                        >
                                            <Link
                                                style={{color: '#000'}}
                                                to={{
                                                    pathname: "/ad-sas-school/cau-hinh-gia-hoc-phi"
                                                }}
                                            >
                                                Hủy bỏ
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(EditFeeManagement)
